import { useState, useRef, useEffect } from "react"
import { ShowMessage } from "../alert"
import { mainApi } from "../api"
import { useReactToPrint } from "react-to-print"
import { useParams, useNavigate } from "react-router-dom"
import { getStorage } from "../storage"
const Penalty = () => {
    const { id } = useParams();
    const [penaltyInfo, setPenaltyInfo] = useState();
    const [PASSDATE, SETPASSDATE] = useState();
    const [REGISTER, SETREGISTER] = useState();
    const [LASTNAME, SETLASTNAME] = useState();
    const [FIRSTNAME, SETFIRSTNAME] = useState();
    const [DRIVERNO, SETDRIVERNO] = useState();
    const [PLATENUMBER, SETPLATENUMBER] = useState();
    const [LOCALNAME, SETLOCALNAME] = useState();
    const [LEGAL, SETLEGAL] = useState();
    const [IN_AMOUNT, SETIN_AMOUNT] = useState();
    const [DEPARTNAME, SETDEPARTNAME] = useState();
    const [WORKER, SETWORKER] = useState();

    const navigate = useNavigate()

    const getPenaltyInfo = async () => {


        let data = {
            "barcode": id
        };
        try {
            const response = await mainApi({ url: "/police/getPenaltyInfo", data });
            console.log("RESONSE IN AUTH getPenaltyInfo", response);
            setPenaltyInfo(response.data)
            SETPASSDATE(response.data.PASSDATE);
            SETREGISTER(response.data.REGISTER);
            SETLASTNAME(response.data.LASTNAME);
            SETFIRSTNAME(response.data.FIRSTNAME.toUpperCase());
            SETDRIVERNO(response.data.DRIVERNO);
            SETPLATENUMBER(response.data.PLATENUMBER);
            SETLOCALNAME(response.data.LOCALNAME);
            SETLEGAL(response.data.LEGAL);
            SETIN_AMOUNT(response.data.IN_AMOUNT);
            SETDEPARTNAME(response.data.DEPARTNAME);
            SETWORKER(response.data.WORKER);

        }
        catch (error) {
            ShowMessage(error)
        }
    }
    useEffect(() => {
        let tkn = getStorage("token");
        let idd = getStorage("id");

        if (!tkn || !idd || idd != id) {
            navigate("/notfound")
        } else
            getPenaltyInfo();
    }, []);

    // Ref for printing the component
    const contentRef = useRef();

    // Print the page
    const handlePrint = useReactToPrint({
        content: () => contentRef.current,
    });

    return (
        <div className="container mx-auto p-4 ">
            {/* Printable Table */}
            <div className="flex justify-center items-center" ref={contentRef}>
                <div className="max-w-[794px] w-full p-4 sm:p-8 text-center">
                    <h2 className="text-lg mb-4 text-center">ХЯЛБАРШУУЛСАН ЖУРМААР ШИЙДВЭРЛЭХ ЗӨРЧИЛД
                        <br />ШИЙТГЭЛ ОНОГДУУЛАХ ТУХАЙ</h2>
                    <h2 className="text-lg font-semibold mb-4 text-center">ШИЙТГЭЛИЙН ХУУДАС <br />(маягт 3) </h2>
                    <p className="fmb-4 text-center">Дугаар: {id}</p>
                    <p className="fmb-4 text-center mb-4">Огноо: {PASSDATE}</p>
                    <p className="fmb-4 text-justify mb-4">
                        <span className="font-semibold">{REGISTER}</span> регистрийн дугаартай <span className="font-semibold">{LASTNAME}-н {FIRSTNAME}</span> (<span className="font-semibold">{PLATENUMBER}</span> дугаартай тээврийн хэрэгсэл, <span className="font-semibold">{DRIVERNO}</span> дугаартай жолоодох эрхийн үнэмлэх болон иргэний үнэмлэх гэх мэт) нь <span className="font-semibold">{LOCALNAME} {LEGAL}</span> заасныг зөрчсөн тул <span className="font-semibold">{IN_AMOUNT}</span> төгрөгөөр торгох шийтгэл оногдуулав.
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Шийдвэр гаргасан: <span className="font-semibold">{WORKER} ({DEPARTNAME})</span></p>
                    <div className="overflow-x-auto">

                        <div className="">

                            <h3 className="font-semibold mt-4 text-center">САНАМЖ </h3>

                            <ol className="list-decimal text-justify pl-5 space-y-2">
                                <li>Та Зөрчил шалган шийдвэрлэх тухай хуулийн 7.5 дугаар зүйлийн 2 дахь хэсэгт заасныг үндэслэн торгуулийг 15 хоногийн дотор Зөвлөмж хэсэгт заасны дагуу төлөхийг анхаарна уу.</li>
                                <li>Та энэхүү шийдвэрийг эс зөвшөөрвөл Зөрчил шалган шийдвэрлэх тухай хуулийн 7.7 дугаар зүйлд тус тус заасны дагуу шийдвэрийг хүлээн авснаас хойш ажлын 5 өдрийн дотор гомдол гаргах эрхтэй.</li>
                                <li>Хэрэв заасан хугацаанд торгуулийг сайн дураар төлөөгүй тохиолдолд шүүхийн шийдвэр гүйцэтгэлийн журмаар албадан төлүүлэх болохыг анхаарна уу.</li>
                            </ol>
                            <h3 className="font-semibold mt-4 text-center">ЗӨВЛӨМЖ </h3>

                            <ul className="text-justify pl-5 space-y-2">
                                <li>Та E-Mongolia системийн "Иргэн, жолооч, авто тээврийн хэрэгслийн торгуулийн төлбөр төлөх" үйлчилгээг ашиглан торгуулийн төлбөрөө төлнө үү.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Print and Download Buttons */}
            <div className="mt-4 text-center">
                <button
                    onClick={handlePrint}
                    className="bg-blue-500 text-white px-4 py-2 mr-2 rounded hover:bg-blue-600"
                >
                    Хэвлэх
                </button>
            </div>
        </div>
    );
}

export default Penalty